import { useState } from "react";
import { useNavigate } from "react-router-dom";

import backArrow from "../../../assets/backArrow.png";
import HowStart from "../../../assets/game/howStart.png";
import Re from "../../../assets/game/Re.png";
import Level from "../../../assets/game/LevelsandMil.png";

// Bottom menu icons
import aboutActive from "../../../assets/game/aboutActive.png";
import Reward from "../../../assets/game/Reward.png";
import Levels from "../../../assets/game/Levels.png";
import active from "../../../assets/game/active.png";
import rewardActive from "../../../assets/game/rewardActive.png";
import levelsActive from "../../../assets/game/levelsActive.png";

const Guidelines = ({setGameguidelines,tagOrder}) => {
  const [activeMenu, setActiveMenu] = useState(1);
  const navigate = useNavigate();

  const handleMenu = (active) => {
    setActiveMenu(active);
  };

  const HeaderSecondary = ({ title }) => {
    const handleBack = () =>{ 
 if(tagOrder){
      setGameguidelines(false)
 }
 else{
      navigate("/");
 }
    
    
    }

    return (
      <div
        className="h-[60px] flex items-center px-5 "

        style={{ backgroundColor: "#fae14b" }}
      >
        <img
          src={backArrow}
          alt="Back"
          style={{ width: "24px", cursor: "pointer" }}
          onClick={handleBack}
        />
        <p className="ml-2 font-body font-medium text-gray-800">{title}</p>
      </div>
    );
  };

  const BottomMenu = () => {
    return (
      <div
        style={{
          background: "#b45d24",
          width: "100vw",
          height: "14vw",
          position: "fixed",
          bottom: 0,
          display: "flex",
          justifyContent: "space-around",
        }}
      >
        {/* Menu Item 1 */}
        {activeMenu === 1 ? (
          <div style={{ position: "relative", top: "-20px" }}>
            <img src={aboutActive} alt="About Active" style={{ width: "15vw" }} />
          </div>
        ) : (
          <div style={{ position: "relative", top: "2px" }}>
            <img
              src={active}
              alt="About"
              style={{ width: "15vw" }}
              onClick={() => handleMenu(1)}
            />
          </div>
        )}

        {/* Menu Item 2 */}
        {activeMenu === 2 ? (
          <div style={{ position: "relative", top: "-20px" }}>
            <img src={rewardActive} alt="Reward Active" style={{ width: "15vw" }} />
          </div>
        ) : (
          <div style={{ position: "relative", top: "2px" }}>
            <img
              src={Reward}
              alt="Reward"
              style={{ width: "15vw" }}
              onClick={() => handleMenu(2)}
            />
          </div>
        )}

        {/* Menu Item 3 */}
        {activeMenu === 3 ? (
          <div style={{ position: "relative", top: "-20px" }}>
            <img src={levelsActive} alt="Levels Active" style={{ width: "15vw" }} />
          </div>
        ) : (
          <div style={{ position: "relative", top: "2px" }}>
            <img
              src={Levels}
              alt="Levels"
              style={{ width: "15vw" }}
              onClick={() => handleMenu(3)}
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="guidelines">
      <HeaderSecondary title="Guidelines" />

      {activeMenu === 1 && (
        <img
          src={HowStart}
          alt="How to Start"
          style={{ height: "85vh", width: "100vw", padding: "5%", paddingBottom: "10vw" }}
        />
      )}

      {activeMenu === 2 && (
        <img
          src={Re}
          alt="Rewards"
          style={{ height: "85vh", width: "100vw", padding: "5%", paddingBottom: "10vw" }}
        />
      )}

      {activeMenu === 3 && (
        <img
          src={Level}
          alt="Levels"
          style={{ height: "85vh", width: "100vw", padding: "5%", paddingBottom: "10vw" }}
        />
      )}

      <BottomMenu />
    </div>
  );
};

export default Guidelines;
